import React, { useRef, useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import useMyMApi from '../hooks/useMyMApi';

/** MyMine Version3.0 PdfViewer新規追加
* PdfViwer Content
*/

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/lib/pdf.worker.min.mjs`;

const PdfViewer = (props) => {
  const screenId = 'MyM301';
  const apiRequest = useMyMApi(screenId);
  const [numPages, setNumPages] = useState(null);
  const [isPdfLoaded, setIsPdfLoaded] = useState(false);
  const [containerWidth, setContainerWidth] = useState(718);
  const containerRef = useRef();


  // 親Boxの横幅に合わせてリサイズ
  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const setPdfLinksToBlank = () => {
    document.querySelectorAll('.react-pdf__Page [id*=pdfjs_internal_id]').forEach(link => {
      if (link.getAttribute('href')?.startsWith('http')) {
        link.target = '_blank';
        link.dataset.blankified = "true";
        link.addEventListener('click', e => {
          e.preventDefault();
          apiRequest.requestJson('api/sales/lv1_URL?lv1_href=' + link.href, 'GET', null, null, null);
          window.open(link.href, "_blank");
        });
      }
    });
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setIsPdfLoaded(true);
    setPdfLinksToBlank();
  };

  const onRenderSuccess = () => {
    setTimeout(() => {
      setPdfLinksToBlank();
    } ,100)
    setIsPdfLoaded(true);
  };


  return (
    <div ref={containerRef}>
      {props.file ? (
        <Document file={props.file} onLoadSuccess={onDocumentLoadSuccess} loading={null}>
          {isPdfLoaded && numPages ? (
            <Page
              pageNumber={1}
              width={containerWidth}
              renderAnnotationLayer={true}
              renderTextLayer={true}
              onRenderSuccess={onRenderSuccess}
              loading={null}
              error={null}
            />
          ) : null}
        </Document>
      ) : (
        <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
      )}
    </div>
  );
};

export default PdfViewer;
